import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import { Briefcase } from "lucide-react";

const COMPANIES = [
  "GOOGLE", "MICROSOFT", "APPLE", "AMAZON", "META", "ADOBE", "TESLA",
  "NETFLIX", "NVIDIA", "INTEL", "IBM", "ORACLE", "SALESFORCE", "UBER", "STRIPE",
];

const SALARIES = [
  { amt: "$125K", cur: "USD" },
  { amt: "£98K", cur: "GBP" },
  { amt: "€142K", cur: "EUR" },
  { amt: "AED 380K", cur: "DIRHAM" },
  { amt: "A$185K", cur: "AUD" },
  { amt: "$72K", cur: "USD" },
  { amt: "£165K", cur: "GBP" },
  { amt: "€88K", cur: "EUR" },
  { amt: "AED 240K", cur: "DIRHAM" },
  { amt: "A$110K", cur: "AUD" },
  { amt: "$195K", cur: "USD" },
  { amt: "£54K", cur: "GBP" },
  { amt: "€76K", cur: "EUR" },
  { amt: "AED 425K", cur: "DIRHAM" },
  { amt: "A$92K", cur: "AUD" },
];

function CompanyName({ name }) {
  return (
    <span className="font-anton leading-none text-white tracking-tight px-5 md:px-6 text-[14vw] md:text-[11vw] lg:text-[9rem] [text-shadow:_6px_6px_0_#282829]">
      {name}
    </span>
  );
}

function SalaryTag({ amt, cur }) {
  return (
    <div className="flex items-center gap-3">
      <span className="font-anton leading-none text-white tracking-tight px-4 md:px-5 text-[10vw] md:text-[7vw] lg:text-[5.5rem]">
        {amt}
      </span>
      <span className="font-anton uppercase tracking-[0.2em] px-3 py-1 rounded-full border-2 border-white text-[10px] md:text-xs bg-[#c92e34] text-white">
        {cur}
      </span>
    </div>
  );
}

export default function AlumniShowcase() {
  return (
    <section
      className="relative bg-[#c92e34] text-white border-y-[3px] border-[#282829] overflow-hidden"
      data-testid="alumni-showcase-section"
    >
      <div aria-hidden className="absolute inset-0 opacity-[0.12] pointer-events-none" style={{
        backgroundImage: "radial-gradient(#fff 1.2px, transparent 1.2px)",
        backgroundSize: "26px 26px"
      }} />

      <div className="relative max-w-7xl mx-auto px-6 sm:px-10 pt-16 pb-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="inline-flex items-center gap-2 bg-[#282829] text-white text-xs font-bold tracking-widest uppercase px-3 py-1 rounded-full border-2 border-white rotate-2"
        >
          <Briefcase size={12} />
          Alumni Network · 2500+ Placements
        </motion.div>
        <h2 className="font-display text-5xl sm:text-6xl md:text-7xl lg:text-8xl mt-4 leading-[0.88] uppercase">
          Our Alumni<br />
          <span className="inline-block">
            Work
            <span className="font-handwritten text-[#282829] mx-2 inline-block -rotate-2">here</span>.
          </span>
        </h2>
        <p className="mt-5 text-white/85 max-w-xl mx-auto text-base md:text-lg">
          From Silicon Valley to Soho — at packages that make the move make sense.
        </p>
      </div>

      {/* Strip 1: COMPANY NAMES */}
      <div className="relative py-8 md:py-12 border-t-2 border-b-2 border-[#282829] bg-[#c92e34]">
        <div className="max-w-7xl mx-auto px-6 mb-3 flex items-center gap-2 text-[10px] font-bold tracking-widest uppercase text-white/80">
          <span className="w-6 h-px bg-white/40" /> Companies
        </div>
        <Marquee gradient={false} speed={105} pauseOnHover direction="left">
          {COMPANIES.map((name, i) => (
            <div key={`co-${name}-${i}`} className="flex items-center">
              <CompanyName name={name} />
              <span className="mx-4 md:mx-6 w-4 h-4 md:w-6 md:h-6 rounded-full bg-white border-2 border-[#282829] flex-shrink-0" />
            </div>
          ))}
        </Marquee>
      </div>

      {/* Strip 2: SALARIES */}
      <div className="relative py-6 md:py-8 border-b-2 border-[#282829] bg-[#282829] text-white">
        <div className="max-w-7xl mx-auto px-6 mb-3 flex items-center gap-2 text-[10px] font-bold tracking-widest uppercase text-[#c92e34]">
          <span className="w-6 h-px bg-[#c92e34]/50" /> Starting Packages
        </div>
        <Marquee gradient={false} speed={85} pauseOnHover direction="right">
          {SALARIES.map((s, i) => (
            <div key={`sal-${i}`} className="flex items-center">
              <SalaryTag amt={s.amt} cur={s.cur} />
              <span className="mx-3 md:mx-5 w-3 h-3 md:w-4 md:h-4 rounded-full bg-[#c92e34] border-2 border-white flex-shrink-0" />
            </div>
          ))}
        </Marquee>
      </div>

      <div className="relative py-10 text-center">
      </div>
    </section>
  );
}
